import React, {useState} from 'react';
import {useAuth} from "../../providers/AuthProvider.jsx";
import {Navigate} from "react-router";

const GoogleAuthProcessing = (props) => {
    document.title = 'Authenticating | Likengale';

    return (
        <>
            <div className="text-center">
                <h4 className="mb-0">Authenticating...</h4>
            </div>
        </>
    );
}

export default GoogleAuthProcessing;
